import { Injectable } from '@angular/core';
import { DataFiltered } from 'app/shared/models/class/filterPopupTable/filterPopUpTable';
import { SubscriptionBaseComponent } from 'app/shared/subscriptionBase/subscription-base';
import { BehaviorSubject } from 'rxjs';
import { BookingService } from '../booking/booking.service';
import { BookingStatus } from 'app/shared/models/class/bookedOffer/bookedOffer';

@Injectable({
  providedIn: 'root'
})
export class FilterpredicateService extends SubscriptionBaseComponent {
  dataFilteredTable$ = new BehaviorSubject<any[]>([]);
  dataFilteredTable: any[];
  bookingStatus: BookingStatus[];

  constructor(
    private bookingService: BookingService,
  ) {
    super();
    this.getBookingStatus();
    this.initSub();
  }


  getFilterPredicate(dataSource: object) {
    return (data: any, filter) => {
      const filterPars = JSON.parse(filter);
      const dataCheck = new DataFiltered(data, false);

      const columnData = {
        offername: data.offerName?.toLowerCase() || null,
        bookingreference: data?.bookingReference?.toLowerCase() || null,
        price: data?.price?.toLowerCase() || null,
        bookingamount: data.bookingAmount || null,
        bookingGlobalStatus: data.bookingGlobalStatus?.toLowerCase() || null,
        ressources: data.ressources?.toLowerCase() || null,
      };

      const indexData = this.dataFilteredTable.findIndex(el => el.offerKey === dataCheck.data.offerKey);
      const dataStringify = [data.offerName, data.bookingReference, data.price, data.bookingPayedAmount, data.bookingGlobalStatus, data.ressources].join('|');

      filterPars.forEach((f, i) => {
        f.values.forEach((kw, iKw) => {

          switch (f.column) {
            case 'search':
              // const dataStringify = JSON.stringify(data).toLocaleLowerCase();
              const index = dataStringify.toLocaleLowerCase().includes(f.values[0]);

              if (i < 1) {
                if (index) {
                  dataCheck.isInFilter = true;
                }
              }
              else if (i >= 1) {

                dataCheck.isInFilter = indexData !== -1 && index ? true : false;

              }
              break;

            default:

              if (isNaN(columnData[f.column])) {
                if (i < 1) {
                  if (columnData[f.column]?.toString().includes(kw)) {
                    dataCheck.isInFilter = true;
                  }
                } else if (i >= 1) {
                  if (iKw < 1) {
                    if (indexData !== -1) { dataCheck.isInFilter = columnData[f.column]?.toString().includes(kw) ? true : false; }
                  } else {
                    if (indexData !== -1 && !dataCheck.isInFilter) {
                      dataCheck.isInFilter = columnData[f.column]?.toString().includes(kw) ? true : false;
                    }
                  }
                }

              } else {

                if (i < 1) {
                  if (columnData[f.column] === (kw)) {
                    dataCheck.isInFilter = true;
                  }
                } else if (i >= 1) {
                  if (iKw < 1) {
                    if (indexData !== -1) { dataCheck.isInFilter = columnData[f.column] === kw ? true : false; }
                  } else {
                    if (indexData !== -1 && !dataCheck.isInFilter) {
                      dataCheck.isInFilter = columnData[f.column] === kw ? true : false;
                    }
                  }
                }
              }
              break;
          }
        });
      });

      return filterPars?.length ? dataCheck.isInFilter : true;
    };
  }

  returStatus(statusKey: number): BookingStatus {
    return this.bookingStatus?.find(status => status.bookedOfferStatusKey === statusKey);
  }

  private getBookingStatus(): void {
    this.bookingService.getBookingStatus().subscribe({
      next: bookingStatus => {
        this.bookingStatus = bookingStatus;
      }
    });
  }

  private initSub(): void {
    this.subscription
      .add(
        this.dataFilteredTable$.subscribe({
          next: async dataFilteredTable => {
            for (const o of dataFilteredTable) {
              o.bookingStatusKeyName = await this.returStatus(o.bookingStatusKey)?.bookedOfferStatus;
            }
            this.dataFilteredTable = dataFilteredTable;
          }
        })
      );
  }
}
